import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SessionManager({ timeout = 10 * 60 * 1000 }) {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const clearSessionAndLogout = (reason) => {
    console.warn('SessionManager: Clearing session and logging out. Reason:', reason || 'timeout');
    try {
      sessionStorage.clear();
      // also remove token fallback from localStorage if present
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('userDetails');
    } finally {
      navigate('/login');
    }
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    // defensive: ensure timeout is a positive number
    const t = typeof timeout === 'number' && isFinite(timeout) && timeout > 0 ? timeout : 10 * 60 * 1000;
    console.debug('SessionManager: resetTimer called, next timeout (ms):', t);
    timerRef.current = setTimeout(() => {
      clearSessionAndLogout('inactivity');
    }, t);
  };

  useEffect(() => {
    console.debug('SessionManager mounted with timeout:', timeout);
    const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll'];

    events.forEach((ev) => window.addEventListener(ev, resetTimer));

    // initialize
    resetTimer();

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
